'use client';

import { c as _c } from "react/compiler-runtime";
import { Tag } from '@eversports/klimt-primitives/Tag';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import SeoLink from '../../../../../../../components/seoLink';
import type { Locale } from '../../../../../../../localization/i18n';
import { Routes } from '../../../../../../App.constants';
import { PLACEHOLDER_IMAGE } from '../../../../../../App.images';
import StarRating from '../../../../../../components/StarRating';
import formatLocation from '../../../../../../lib/format-location';
import getDifferenceInMinutes from '../../../../../../utils/get-difference-in-minutes';
import { LEVEL_TRANSLATION_MAPPING } from './ActivityCard.constants';
import type { EventBookableItem } from './ActivityCard.types';
import RegistrationStateBadges from './components/RegistrationStateBadges';
import formatDate from './helpers/format-date';
import formatTime from './helpers/format-time';
interface Props {
  activity: EventBookableItem;
  locale: Locale;
  hasPriority?: boolean;
}
const ActivityCard = t0 => {
  const $ = _c(87);
  const {
    activity,
    locale,
    hasPriority: t1
  } = t0;
  const hasPriority = t1 === undefined ? false : t1;
  const translate = useTranslations("discover-sport-city");
  if (!activity.eventSessions.length) {
    return null;
  }
  const {
    venue: t2,
    sport,
    level,
    registrationState,
    location,
    eventSessions
  } = activity;
  const {
    id: venueId,
    name: venueName,
    rating,
    reviewCount
  } = t2;
  const {
    id,
    name,
    start,
    end,
    image,
    hasOnlineStream,
    availableSpots
  } = eventSessions[0];
  let T0;
  let address;
  let isOutdoor;
  let levelTranslationKey;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== end || $[1] !== hasOnlineStream || $[2] !== id || $[3] !== level || $[4] !== locale || $[5] !== location || $[6] !== name || $[7] !== start || $[8] !== translate) {
    const date = formatDate({
      dateStr: start,
      locale,
      timeZone: "Europe/Vienna"
    });
    const startTime = formatTime({
      dateStr: start,
      locale,
      timeZone: "Europe/Vienna"
    });
    const endTime = formatTime({
      dateStr: end,
      locale,
      timeZone: "Europe/Vienna"
    });
    const duration = getDifferenceInMinutes(start, end);
    let t11;
    if ($[21] !== location) {
      t11 = location ? formatLocation(location) : undefined;
      $[21] = location;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    address = t11;
    isOutdoor = !hasOnlineStream && location && !location.indoor;
    levelTranslationKey = level && LEVEL_TRANSLATION_MAPPING[level];
    t10 = "relative overflow-hidden border border-border-divider bg-white shadow-sm focus-within:ring-3 hover:shadow-md sm:rounded-md";
    T0 = SeoLink;
    t7 = "flex h-full flex-col justify-between px-2 py-3";
    t8 = "hidden";
    const t12 = `${Routes.ACTIVITY_DETAILS}/${id}`;
    if ($[23] !== t12) {
      t9 = btoa(t12);
      $[23] = t12;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t5 = "flex flex-col";
    if ($[25] !== name) {
      t6 = <h2 className="truncate font-bold">{name}</h2>;
      $[25] = name;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    t3 = "mb-2 text-base";
    t4 = translate("activity-date-time", {
      date,
      startTime,
      endTime,
      duration
    });
    $[0] = end;
    $[1] = hasOnlineStream;
    $[2] = id;
    $[3] = level;
    $[4] = locale;
    $[5] = location;
    $[6] = name;
    $[7] = start;
    $[8] = translate;
    $[9] = T0;
    $[10] = address;
    $[11] = isOutdoor;
    $[12] = levelTranslationKey;
    $[13] = t10;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[9];
    address = $[10];
    isOutdoor = $[11];
    levelTranslationKey = $[12];
    t10 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[27] !== t3 || $[28] !== t4) {
    t11 = <span className={t3}>{t4}</span>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = image?.small || PLACEHOLDER_IMAGE;
  const t13 = hasPriority ? "eager" : "lazy";
  let t14;
  if ($[30] !== hasPriority || $[31] !== t12 || $[32] !== t13) {
    t14 = <Image src={t12} alt="" loading={t13} priority={hasPriority} width={100} height={68} className="h-[68px] w-[100px] shrink-0 rounded-md object-cover" />;
    $[30] = hasPriority;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== venueName) {
    t15 = <span className="truncate">{venueName}</span>;
    $[34] = venueName;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== rating || $[37] !== venueId) {
    t16 = <StarRating rating={rating} venueId={venueId} size="small" />;
    $[36] = rating;
    $[37] = venueId;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = Number(rating);
  let t18;
  if ($[39] !== t17) {
    t18 = t17.toFixed(2);
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== reviewCount || $[42] !== t16 || $[43] !== t18) {
    t19 = <div className="flex items-center gap-0.5 text-sm text-text-secondary">{t16}{t18} ({reviewCount})</div>;
    $[41] = reviewCount;
    $[42] = t16;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== address || $[46] !== hasOnlineStream || $[47] !== translate) {
    t20 = hasOnlineStream ? translate("online") : address && <span>{address}</span>;
    $[45] = address;
    $[46] = hasOnlineStream;
    $[47] = translate;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t15 || $[50] !== t19 || $[51] !== t20) {
    t21 = <div className="flex flex-col gap-0.5 overflow-hidden border-l border-border-divider pl-1 text-base">{t15}{t19}{t20}</div>;
    $[49] = t15;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t14 || $[54] !== t21) {
    t22 = <div className="mb-2 flex gap-1">{t14}{t21}</div>;
    $[53] = t14;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t11 || $[57] !== t22 || $[58] !== t5 || $[59] !== t6) {
    t23 = <div className={t5}>{t6}{t11}{t22}</div>;
    $[56] = t11;
    $[57] = t22;
    $[58] = t5;
    $[59] = t6;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== sport.name) {
    t24 = <Tag variant="custom" style="outline" text={sport.name} />;
    $[61] = sport.name;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== levelTranslationKey || $[64] !== translate) {
    t25 = levelTranslationKey && <Tag variant="custom" style="outline" text={translate(levelTranslationKey)} />;
    $[63] = levelTranslationKey;
    $[64] = translate;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== isOutdoor || $[67] !== translate) {
    t26 = isOutdoor && <Tag variant="custom" style="outline" text={translate("offering-outdoor")} />;
    $[66] = isOutdoor;
    $[67] = translate;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== availableSpots || $[70] !== registrationState) {
    t27 = <RegistrationStateBadges availableSpots={availableSpots} registrationState={registrationState} />;
    $[69] = availableSpots;
    $[70] = registrationState;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== t24 || $[73] !== t25 || $[74] !== t26 || $[75] !== t27) {
    t28 = <div className="flex flex-wrap gap-1 capitalize">{t24}{t25}{t26}{t27}</div>;
    $[72] = t24;
    $[73] = t25;
    $[74] = t26;
    $[75] = t27;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== T0 || $[78] !== t23 || $[79] !== t28 || $[80] !== t7 || $[81] !== t8 || $[82] !== t9) {
    t29 = <T0 className={t7} type={t8} encodedTo={t9}>{t23}{t28}</T0>;
    $[77] = T0;
    $[78] = t23;
    $[79] = t28;
    $[80] = t7;
    $[81] = t8;
    $[82] = t9;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  let t30;
  if ($[84] !== t10 || $[85] !== t29) {
    t30 = <li className={t10}>{t29}</li>;
    $[84] = t10;
    $[85] = t29;
    $[86] = t30;
  } else {
    t30 = $[86];
  }
  return t30;
};
export default ActivityCard;